/**
 * misradia — shared reading of search queries (printer search + products on printer pages).
 *
 * Printer names are Latin, product titles mix Hebrew and Latin, and shoppers type either — often
 * a brand in Hebrew ("ברדר") or Latin with the Hebrew keyboard layout still on ("צכב" = "mfc").
 * readings() returns every way to read a query; a result matches if it satisfies any of them.
 *
 * Used by: sections/Printer_search.liquid, assets/compatible-products.js
 */
(function () {
  var HEBREW = /[֐-׿]/;

  // Hebrew spellings of brands and series → the Latin name used in printer names and product titles.
  var HEBREW_TERMS = [
    [/ב[רא]+ו?[דז]'?ר/g, 'brother'],
    [/ק[א]?נון/g, 'canon'],
    [/א[יי]*[צץ]'?\s?פי/g, 'hp'],
    [/אפסו?ן/g, 'epson'],
    [/(?:זי|קס|ז)רוקס/g, 'xerox'],
    [/סמסונג/g, 'samsung'],
    [/לקסמרק/g, 'lexmark'],
    [/לייזר\s?ג'?ט/g, 'laserjet'],
    [/אופיס\s?ג'?ט/g, 'officejet'],
    [/דסק\s?ג'?ט/g, 'deskjet'],
    [/פיקסמה/g, 'pixma'],
    [/פוטו\s?סמארט/g, 'photosmart'],
    [/מקסיפיי/g, 'maxify'],
  ];

  // Standard Israeli keyboard (SI-1452): the Hebrew letter on each QWERTY key.
  var HEBREW_LAYOUT = {
    '/': 'q', "'": 'w', 'ק': 'e', 'ר': 'r', 'א': 't', 'ט': 'y', 'ו': 'u', 'ן': 'i', 'ם': 'o', 'פ': 'p',
    'ש': 'a', 'ד': 's', 'ג': 'd', 'כ': 'f', 'ע': 'g', 'י': 'h', 'ח': 'j', 'ל': 'k', 'ך': 'l', 'ף': ';',
    'ז': 'z', 'ס': 'x', 'ב': 'c', 'ה': 'v', 'נ': 'b', 'מ': 'n', 'צ': 'm', 'ת': ',', 'ץ': '.',
  };

  function compact(text) {
    return String(text || '').toLowerCase().replace(/[\s\-_./]+/g, '');
  }

  function fromHebrewTerms(text) {
    var out = text.replace(/[׳`’]/g, "'");
    HEBREW_TERMS.forEach(function (pair) { out = out.replace(pair[0], pair[1]); });
    return out;
  }

  function fromHebrewLayout(text) {
    return text.replace(/./g, function (ch) { return HEBREW_LAYOUT[ch] || ch; });
  }

  function readings(term) {
    var query = String(term || '').trim().toLowerCase();
    if (!query) return [];
    var list = [query];
    if (HEBREW.test(query)) {
      list.push(fromHebrewTerms(query));
      list.push(fromHebrewLayout(query));
    }
    return list.filter(function (q, i) { return q && list.indexOf(q) === i; });
  }

  window.misradiaSearchTerms = {readings: readings, compact: compact, hasHebrew: function (t) { return HEBREW.test(t); }};
})();
